<cfp-login-layout>
  <router-outlet />
  <cfp-footer-text belowRow />
</cfp-login-layout>
